import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink, faCheck } from '@fortawesome/free-solid-svg-icons'
import ClipboardButton from 'react-clipboard.js'

export default class VideoUrl extends Component {
  constructor() {
    super()
    this.state = {
      copied: false,
    }
  }

  render() {
    const { url, shortcode } = this.props
    if (!url) {
      return (<div></div>)
    }

    return (
      <div style={{ position: 'relative' }} className="video-url">
        <a id="video-url-input" href={url} target="_blank" value={url}>{url}</a>
        <ClipboardButton
          component="a"
          data-clipboard-text={url}
          onSuccess={() => {
            this.setState({ copied: true })
            setTimeout(
                () => {
                  this.setState({ copied: false })
                },
                3000,
              )
          }}
        >
          {this.state.copied ? <span className="link-button copied"><FontAwesomeIcon icon={faCheck} /> Copied</span> : <span className="link-button"><FontAwesomeIcon icon={faLink} /> Copy Link</span>}
        </ClipboardButton>
      </div>
    )
  }
}
